import React from 'react';
import { Trans, useTranslation } from "react-i18next";
import classNames from "classnames";
import { Alert } from 'reactstrap';
import { useOrganisationContext } from 'hooks';

const LayoutHome = (props) => {
    const { t, i18n } = useTranslation();
    const dir = i18n.dir();

    const { selectedOrganisation } = useOrganisationContext()
    const subscriptionRemainingDays = selectedOrganisation?.subscription_remaining_days || 0

    let subscriptionAlertMsg = null

    if (!selectedOrganisation?.has_upcoming_subscription) {
        if (subscriptionRemainingDays === 1) {
            subscriptionAlertMsg = t(`You will lose access to the system for selected organisation after ${subscriptionRemainingDays} day.`)
        } else if (subscriptionRemainingDays > 1 && subscriptionRemainingDays <= 30) {
            subscriptionAlertMsg = t(`Your subscription will end for selected organisation in ${subscriptionRemainingDays} days.`)
        }
    }

    return (
        // <div> LayoutHome {children}</div>
        <>
            <div id="main" dir={dir} className={dir} style={{ flex: "1 0 auto" }}>
                {props.children}
                <div className="page-wrapper d-block">
                    {subscriptionAlertMsg && (
                        <Alert color="warning" className="text-center text-sm py-1">
                            <strong>
                                {subscriptionAlertMsg}
                            </strong>
                        </Alert>
                    )}

                    <div className="page-content container-fluid">
                        {props.body}
                    </div>
                </div>
                {/* <div className="loader-holder" id="loader-holder"> </div> */}
                <div dir={dir} className={classNames(dir, "d-print-none")}>
                    {/* {!user ? <Footer /> : <></>} */}
                    {/* {_showHeader ? <Footer /> : null} */}
                    {/* { (_showHeader && !user ) ? <Footer /> : null} */}
                </div>
            </div>
        </>
    );
}
export default LayoutHome;
